


















import { Vue, Component, Prop } from 'vue-property-decorator';
import { CouponAdConf } from '@/types/we-coupons';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import { isShowMiniapp } from '@/business/miniapp';

@Component({
  components: {
    LanuchWeapp,
  },
})
export default class CouponAd extends Vue {
  /** 广告位信息 */
  @Prop() adInfo!: CouponAdConf;

  /** 是否是小程序广告 */
  get isMiniapp() {
    return isShowMiniapp(this.adInfo);
  }

  /** 点击广告 */
  handleClickAd() {
    if (this.isMiniapp) {
      this.$emit('weappClick');
    } else {
      this.$emit('click');
    }
  }
}
